import { subMonths } from "date-fns";

import { SearchFilterV4, SearchFilterV4WithDates } from "@/types/SearchFilter";
import { formatDateForApi } from "./format";

export default function withDefaultDates(
  filters: SearchFilterV4
): SearchFilterV4WithDates {
  return {
    ...filters,
    start_date:
      filters.start_date || formatDateForApi(subMonths(new Date(), 3)),
    end_date: filters.end_date || formatDateForApi(new Date()),
  };
}
